export default { launchFlow: {
  draftArcaReadonly: '此处仅供查看 DS 历史设计草稿。后续设计稿由 ARCA 提供，接入尚未开放。',
  manualCreationClosed: '手工建款已关闭。历史资料可查看，已有委托书按原权限维护。',
  createDesign: '创建设计稿', kindDraft: '设计稿', kindSheet: '正式委托书', prototype: 'Prototype · 设计阶段',
  libraryHint: '按开发季、品类或阶段浏览款式、委托书及历史设计草稿。',
  libraryEmpty: '暂无设计稿或委托书', libraryEmptyHint: '可在“我的任务”中接收 SAP 已分配款号。',
  syncQuantities:'同步 SAP 订货数量', quantitySynced:'已核对并更新上游订货数量。', quantityNotProvided:'SAP 暂未提供订货数量，已保留原有数量和待补状态。',
  quantityDimensionsChanged:'上游颜色或尺码范围已变化，请先核对款式资料；本次没有修改委托书数量。',
  quantityInvalid:'上游订货数量无效，本次没有修改委托书。',
  quantitySourceOnly:'此单据不能通过 SAP 更新数量；订货系统来源的单据继续由原来源更新。',
  plannerPaused: '商品企划功能本版本暂未开放，请在 SAP 中维护款号与订货信息。',
  fromSap: '通过 SAP 款号创建', precreate: '从设计稿预建', preSheets: '预建委托书',
  precreateHint: '先用设计师款号保存设计稿、面辅料和备注；正式款号建立后，查询 SAP 并关联。',
  cacheUsed: '使用本地缓存（{age}同步），未调用 SAP。',
  cacheJustNow: '刚刚',
  cacheMinutesAgo: '{n} 分钟前',
  forceRefresh: '强制从 SAP 刷新',
  querySap: '查询 SAP', querying: '正在查询款式、颜色和尺码，请稍候。', stylePlaceholder: '输入完整款号',
  quantityPending: '订货数量待补：仅从 SAP 或订货系统获取，不影响先编制设计资料。',
  styleBrand: '款号与预建委托书的品牌不一致，请核对。',
  queryAndLink: '查询 SAP 正式款号', linkExisting: '关联已有委托书', createAndLink: '创建正式委托书并关联',
  detailUnavailable: 'SAP 颜色尺码查询未成功，本次未更新缓存。请稍后重新查询。',
  dimensionsMissing: 'SAP 尚未提供完整的颜色和尺码，可先从设计稿预建委托书。',
  queryFirst: '请先查询 SAP 款号，取得颜色和尺码后再关联。',
  sheetExists: '该款号已有委托书，请切换到“关联已有委托书”进行核对关联。',
  mergeReviewRequired: '资料存在需要人工核对的差异，尚未创建正式委托书。请先核对预建资料。',
  openFormal: '已关联正式委托书，请在正式委托书中继续编辑。',
}, styleIntake: {
 assignmentAlert:'有 {n} 款的负责人工号缺失或未匹配，请管理员或品牌商品企划补充配置。',configureOwners:'配置负责人',
"runSummary":"品牌接收记录：待源 {waiting} · 异常 {errors} · 超过24小时 {overdue}",
"lastChecked":"最近核对",
"waitingSourceTask":"待 SAP 资料",
"waitingSourceHint":"SAP 品名、颜色或尺码尚未到齐。您可以先处理已分配的工作；已填写内容会保留。",
"waitingOverdue":"待源超过24小时",
"fillTitle":"核对补齐 SAP 资料",
"fillHint":"仅使用已接收的 SAP 资料补齐空白，不覆盖人工填写。",
"fillConfirm":"确认按预览补齐空白资料？已有填写、审批和发厂版本保持。",
"fillApply":"确认补齐",
"fillSaved":"已补齐收到的资料",
"fillEmpty":"当前没有可补齐的空白资料，请等待 SAP 来源到齐。",
"fillMatrix":"补齐颜色 {colors}、尺码 {sizes}；已收到 {n} 个订货数量格，其余保持待补。",
"fillPreserved":"已有人工维护的字段或数量范围保持，请在委托书中核对。",
"scopePending":"请先配置本批接收品牌和年度范围",
"environmentConflict":"原委托书的 SAP 来源环境不匹配，请管理员核查",
"sourceProtected":"资料已有确认、发厂或人工维护保护，请重新核对",
"fillReasons":{"notLegacy":"本单不是 SAP 接收来源","confirmedOrSent":"本单已有完成、审批或发厂记录，不自动补齐","historyLimit":"维护记录较多，请管理员核查后处理","cancelled":"SAP 来源已取消","quantityInvalid":"SAP 数量来源存在冲突，请先核对","matrixTooLarge":"颜色尺码范围超出处理上限"},
"reviewChanges": "核对上游变化",
"compareHint": "以下为两次接收资料的差异；当前委托书内容保持原样。",
"field": "字段",
"previousSource": "原接收资料",
"latestSource": "最新接收资料",
"metadataChanged": "担当标注或接收状态发生变化，请结合待处理原因核对。",
"quantityCell": "数量 · {cell}",
"moreChanges": "共 {n} 项差异，当前展示前 100 项。",
"fields": {"salePriceCurrency":"币种","styleNm": "品名", "productYear": "年度", "season": "季节", "receivingDueDate": "入库要求日期", "salePrice": "售价", "designerNo": "设计师工号", "plannerNo": "商品企划工号", "fabricPurNo": "面料采购工号", "trimPurNo": "辅料采购工号", "productionNo": "生产担当工号", "patternNo": "版师工号", "cadNo": "CAD 工号", "colors": "颜色范围", "sizes": "尺码范围", "cancelled": "上游取消状态"},
  "receiverError": "自动接收需要检查，请查看待处理事项或联系管理员",
  "myStyles":"我的款式","teamStyles":"团队款式","managementTitle":"款式管理","manage":"款号管理","myPending":"待我处理","myApprovals":"待我审批","all":"全部","yearSeason":"年度 / 季节","open":"查看","continue":"处理","noStyles":"暂无款式","noTasks":"当前没有需要您处理的任务","styleCount":"共 {n} 款","actions":{"DESIGNER": "填写设计", "APPROVER": "审批", "PATTERN": "填写尺寸", "FABRIC": "核对材料", "PRODUCTION": "完善工艺单", "PLANNER": "核对数量", "consumption": "填写单耗", "VIEWER": "查看"},"managementTabs":{"assignments": "已有款式分工", "sources": "SAP 接收款式", "intake": "接收异常"},
  "workbench": "款式工作台",
  "refreshStatus": "刷新工作台",
  "autoActive": "SAP 款式自动接收中",
  "autoInactive": "SAP 款式自动接收尚未启用",
  "schemaPending": "自动接收尚未完成准备，请联系管理员",
  "total": "共 {n} 项待处理",
  "noExceptions": "暂无接收待处理事项",
  "state": "处理状态",
  "pendingReason": "待处理原因",
  "keepCurrent": "保留当前委托书",
  "keepConfirm": "已核对上游变化，并保留当前委托书资料？本次不会覆盖现有内容。",
  "intakeIssues": "接收待处理",
  "notFound": "接收记录不存在",
  "changed": "接收资料已变化，请刷新后重新核对",
  "roleIssue": "{role}：{reason}",
  "tabs": {
    "mine": "我的待办",
    "all": "全部款式",
    "exceptions": "待处理"
  },
  "states": {
    "WAITING_SOURCE": "等待资料",
    "REVIEW": "待核对",
    "ERROR": "处理失败",
    "CREATED": "已生成",
    "EXISTING": "已有委托书"
  },
  "reasons": {
    "environmentConflict": "此款已有其他接收环境的委托书，需管理员核对来源",
    "nameMissing": "品名待接收",
    "dimensionsMissing": "颜色或尺码待接收",
    "quantityMissing": "订货数量待补齐",
    "quantityInvalid": "订货数量冲突或无效，需核对上游资料",
    "cancelled": "上游已取消，现有委托书保留待核对",
    "matrixTooLarge": "颜色尺码范围过大，需人工核对",
    "ambiguousIdentity": "款号或批次存在冲突",
    "sourceChanged": "上游资料已变化，需核对后决定是否采用",
    "sheetRemoved": "原委托书已删除，等待人工决定",
    "processingError": "处理失败，请管理员查看接收日志",
    "unmatched": "工号未匹配有效岗位及品牌权限",
    "unassigned": "尚未指定担当",
    "personChanged": "本地分工人员状态已变化"
  }
} };
